import React from "react";
import '../styles/pages/card-view.css';

export const CardView = ({ assetUnitId, assetName, isChecked, toggleCheckbox }) => {
    const handleCheckboxChange = () => {
        toggleCheckbox(assetUnitId);
    };

    return (
        <div className="card" onClick={handleCheckboxChange}>
            <div>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    onClick={(e) => e.stopPropagation()}
                />
            </div>
            <div>
                <div className="asset-id">Asset Id: {assetUnitId}</div>
                <div className="asset-name">Asset Name: {assetName}</div>
            </div>
        </div>
    );
};

export const CardList = ({ data, checkedItems, setCheckedItems, toggleCheckbox }) => {
    return (
        <div className="card-list">
            {data && data.map((item) => (
                <CardView
                    key={item.assetUnitId}
                    assetUnitId={item.assetUnitId}
                    assetName={item.name}
                    isChecked={!!checkedItems[item.assetUnitId]}
                    toggleCheckbox={toggleCheckbox}
                />
            ))}
        </div>
    );
};
